export var PAGE_SIZE = 8;
var getPanelList = function getPanelList(gameRoom) {
  var _gameRoom$games;
  if (!(gameRoom !== null && gameRoom !== void 0 && (_gameRoom$games = gameRoom.games) !== null && _gameRoom$games !== void 0 && _gameRoom$games.length)) return {
    panelList: [],
    pagedGames: [],
    pageNumber: 0,
    gameIndex: 0
  };
  var panelList = gameRoom.games.filter(function (game) {
    return !game.IS_HIDDEN;
  });
  var pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
    return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
  });
  return {
    panelList: panelList,
    pagedGames: pagedGames,
    pageNumber: 0,
    gameIndex: 0
  };
};
export default getPanelList;